import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const RESOURCES_FEATURE_GROUP: FeatureGroup = {
  guid: 'a3d6ec67-9f51-4f12-c345-0a2f3f4dff00',
  name: 'resources',
  description: 'Resources features — view documentation and support links',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
